import { render, staticRenderFns } from "./FTPDetails.vue?vue&type=template&id=23c5ce10&"
import script from "./FTPDetails.vue?vue&type=script&lang=js&"
export * from "./FTPDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports